import {translate} from 'views/module';

const optionsFrom = (map) => {
  return Object.entries(map).reduce((acc, [key, value], index) => {
    acc[key] = {label: value.Title, rank: index, key: key};
    return acc;
  }, {});
};

// Only a source whose list endpoint understands the job kind gets the type filter, so the
// options are built per source rather than once for the module.
const generateFilterOptions = (supportsJobTypeFilter) => {
  const filterOptions = {};

  filterOptions.status = {
    key: 'status',
    label: translate('career.dashboard.JobListings.Filter.Status'),
    rank: 1,
    options: optionsFrom(translate('career.Status')),
    canBeEmpty: false,
  };

  if (supportsJobTypeFilter) {
    filterOptions.jobType = {
      key: 'jobType',
      label: translate('career.dashboard.JobListings.Filter.JobType'),
      rank: 2,
      options: optionsFrom(translate('career.JobType')),
      canBeEmpty: true,
    };
  }

  return filterOptions;
};

export {
  generateFilterOptions,
};
